import request, { POST } from '../../utils/request';

export default body => request('/ala-agreements', { method: POST, body });
